/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown>, view: NonNullable<unknown> }} Consumption_View_Too_LongInputs */



/**
* | output |
* | --- |
* | "Period too long for this view ({max} maximum): use the {view} view or shorten the period." |
*
* @param {Consumption_View_Too_LongInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const consumption_view_too_long = /** @type {((inputs: Consumption_View_Too_LongInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumption_View_Too_LongInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Period too long for this view (${i?.max} maximum): use the ${i?.view} view or shorten the period.`)
	return /** @type {LocalizedString} */ (`Période trop longue pour cette vue (${i?.max} maximum) : utilisez la vue ${i?.view} ou réduisez la période.`)
});